/**
 * MiscLinesTable — paiement divers : répartition du montant payé par compte (charge, actif…), sans passer par Fournisseurs.
 */
import { Plus, Trash2 } from "lucide-react";
import { r2 } from "@/lib/format";
import { AccountSelect, inputCls, money } from "../comptabilite/_shared";

const MISC_TYPES = ["expense", "asset", "liability", "equity", "revenue"];

export function MiscLinesTable({ lines, setLines, amount, accounts, disabled, testId = "misc-lines" }) {
  const total = r2(lines.reduce((s, l) => s + (parseFloat(l.amount) || 0), 0));
  const rest = r2(amount - total);
  const upd = (i, k, v) => setLines((p) => p.map((l, j) => (j === i ? { ...l, [k]: v } : l)));
  const add = () => setLines((p) => [...p, { account_id: "", amount: rest > 0 ? rest : "", description: "" }]);
  const del = (i) => setLines((p) => p.filter((_, j) => j !== i));
  return (
    <div className="border rounded-xl overflow-hidden" data-testid={testId}>
      <div className="px-3 py-2 bg-amber-50 border-b text-xs font-bold uppercase tracking-wide text-amber-900 flex items-center justify-between">
        <span>Imputation par compte</span>
        <span className={`font-mono normal-case tabular-nums ${Math.abs(rest) > 0.005 ? "text-rose-700" : "text-emerald-700"}`} data-testid={`${testId}-rest`}>
          Réparti {money(total)} · Reste {money(rest)}
        </span>
      </div>
      <table className="w-full text-xs">
        <tbody className="divide-y">
          {lines.map((l, i) => (
            <tr key={i} data-testid={`${testId}-row-${i}`}>
              <td className="px-2 py-1.5 w-[45%]"><AccountSelect accounts={accounts} value={l.account_id} onChange={(v) => upd(i, "account_id", v)} types={MISC_TYPES} placeholder="— Compte à imputer —" disabled={disabled} testId={`${testId}-account-${i}`} /></td>
              <td className="px-2 py-1.5"><input value={l.description} onChange={(e) => upd(i, "description", e.target.value)} disabled={disabled} className={inputCls} maxLength={120} placeholder="Description (facultatif)" data-testid={`${testId}-desc-${i}`} /></td>
              <td className="px-2 py-1.5 w-32"><input type="number" step="0.01" min="0" value={l.amount} onChange={(e) => upd(i, "amount", e.target.value)} disabled={disabled} className={`${inputCls} text-right font-mono`} data-testid={`${testId}-amount-${i}`} /></td>
              <td className="px-1 py-1.5 w-8 text-right">{!disabled && lines.length > 1 && <button type="button" onClick={() => del(i)} className="text-rose-500 hover:text-rose-700 p-1" data-testid={`${testId}-del-${i}`}><Trash2 className="w-3.5 h-3.5" /></button>}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {!disabled && (
        <div className="px-2 py-1.5 border-t bg-slate-50">
          <button type="button" onClick={add} className="text-xs text-teal-700 hover:underline inline-flex items-center gap-1" data-testid={`${testId}-add`}><Plus className="w-3 h-3" /> Ajouter une ligne{rest > 0.005 ? ` (reste ${money(rest)})` : ""}</button>
        </div>
      )}
    </div>
  );
}
